module.exports = __webpack_public_path__ + "img/wh.ca189e4f.png";